import { Icon } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import styles from './EmptyNotifications.module.css';

export const EmptyNotifications = () => {
  return (
    <div className={styles.emptyNotifications}>
      <div className={styles.notificationIconWrapper}>
        <Icon icon="bellRing" className={styles.notificationIcon} />
      </div>
      <span className={styles.heading}>
        <Trans>You have no live notifications.</Trans>
      </span>
      <span className={styles.subHeading}>
        <Trans>
          Get notified about apps requiring docs or with an offer here.
        </Trans>
      </span>
    </div>
  );
};
